import { HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_LOADING_CONTEXT_TOKEN = new HttpContextToken(
  () => 'SKIP_GLOBAL_LOADING_CONTEXT_TOKEN',
);
